import { PageProps } from "@/types/page";
import { usePage } from "@inertiajs/react";
import { PropsWithChildren } from "react";
import { ContactUsContext } from "./ContactUsContext";

export function ContactUsProvider({ children }: PropsWithChildren) {
    const { contactUsVariant } = usePage<PageProps>().props;

    return (
        <ContactUsContext.Provider
            value={{ contactUsVariant: contactUsVariant ?? null }}
        >
            {children}
        </ContactUsContext.Provider>
    );
}
